module.exports = __webpack_public_path__ + "static/Futuready-f6fa2890d1c1ef6bcf3784b47ce9ceb2.svg";